import React from 'react'
import { useGoogleLogin } from '@react-oauth/google'
import { Button, ButtonText } from '@/components/ui/button'
import google from '@/assets/images/google.png'
import useLogin from '@/services/api/auth/useLogin'

export default function GoogleLogin({
  setIsLoading,
  isLoading,
  onSuccess,
}: {
  setIsLoading: (isLoading: boolean) => void
  isLoading: boolean
  onSuccess: () => void
}) {
  const { login, loginStatus } = useLogin()
  const googleLogin = useGoogleLogin({
    onNonOAuthError: () => {
      setIsLoading(false)
    },
    onSuccess: (tokenResponse) => {
      login({
        platform: 'google',
        accessToken: tokenResponse.access_token,
      })
        .then(() => {
          onSuccess()
        })
        .finally(() => {
          setIsLoading(false)
        })
    },
    onError: () => {
      setIsLoading(false)
    },
  })
  return (
    <Button
      variant="outline"
      size="lg"
      className="w-full"
      loading={isLoading}
      onClick={() => {
        setIsLoading(true)
        googleLogin()
      }}
    >
      <img src={google} alt="Google" className="size-4" />
      <ButtonText>Continue with Google</ButtonText>
    </Button>
  )
}
